import { EntityEditFormModal } from '../../Entity'
import { getTaskEditDeadlinePayload } from '../../Task'

import { QA_NAME_CALENDAR_TASK_MOVE_MODAL } from './CalendarTaskMoveModal.constants'
import { getCalendarTaskMoveValidationSchema } from './CalendarTaskMoveModal.utils'
import { CalendarTaskMoveModalBody } from './CalendarTaskMoveModalBody'
import { CalendarTaskMoveModalFields } from './CalendarTaskMoveModalFields'

function CalendarTaskMoveModal({ item, onSubmit, ...restProps }) {
  function handleSubmit(params) {
    onSubmit({ ...params, item })
  }

  return (
    <EntityEditFormModal
      {...restProps}
      Fields={CalendarTaskMoveModalFields}
      FormBody={CalendarTaskMoveModalBody}
      formBodyProps={{
        actionsProps: { cancelProps: { title: 'Calendar.MoveAnotherDayKey' } },
        submitButtonText: 'Calendar.MoveAnywayKey',
      }}
      formFieldsProps={{ item }}
      formTitle='Calendar.MoveTaskTitleKey'
      getPayload={getTaskEditDeadlinePayload}
      qaName={QA_NAME_CALENDAR_TASK_MOVE_MODAL}
      validationSchema={getCalendarTaskMoveValidationSchema()}
      onSubmit={handleSubmit}
    />
  )
}

export default CalendarTaskMoveModal
